<template>
  <div>
    <el-dialog
      title="排除商品"
      :visible="showModal"
      :mask-closable="false"
      :append-to-body="true"
      @close="handleCancel"
      width="1000px"
      :body-style="{ padding: '0px' }"
    >
      <bi-tip class="mb20">
        <div>
          说明：1.将小样、赠品进行打标，后续在报表中直接选择标签即可进行排除
        </div>
        <div>
          2.排除说明：仅排除打标商品的金额和件数，如订单中仅含有打标商品，则整单均会被排除，单量、金额、件数均不会被统计
        </div>
      </bi-tip>
      <div class="toolbar">
        <div class="toolbar-right">
          <span class="toolbar-right-tips">*</span>
          <div class="toolbar-right-title">选择标签：</div>
          <bi-button type="blueLine" @click="toCreateTag"> 添加标签 </bi-button>
        </div>
        <div>
          <bi-button type="blueText" @click="handleRefresh"> 刷新 </bi-button>
          <bi-button type="blueText" class="ml12" @click="clearAll"> 一键清空 </bi-button>
        </div>
      </div>
      <div v-loading="initLoading">
        <div class="table">
          <TagCategory v-for="item in list" :key="item.id" :category="item" />
        </div>
      </div>
      <template #footer>
        <div class="footerBtnBox">
          <el-checkbox v-model="localChecked">
            <span class="checkText">应用于全局</span>
          </el-checkbox>
          <span>
            <bi-button @click="handleSure" type="blue">确定</bi-button>
            <bi-button @click="handleCancel" type="gley">取消</bi-button>
          </span>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import TagCategory from "./TagCategory.vue";
import cloneDeep from "lodash/cloneDeep";
export default {
  components: {
    TagCategory,
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => [],
    },
    checked: {
      type: Boolean,
      default: true,
    },
    tagList: {
      type: Array,
      default: () => [],
    },
    initLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: [],
      selectedTagIds: [],
    };
  },
  computed: {
    localChecked: {
      get() {
        return this.checked;
      },
      set(val) {
        this.$emit("update:checked", val);
      },
    },
  },
  watch: {
    showModal(val) {
      if (val) {
        this.selectedTagIds = cloneDeep(this.value);
        this.getList();
      }
    },
    selectedTagIds: {
      handler() {
        this.getList();
      },
      deep: true,
    },
  },
  methods: {
    toCreateTag() {
      if (window.location.origin.includes("yqbi.yucrm.cn")) {
        window.open(
          "https://yqbi.yucrm.cn/bi-web/yunzhou-common/system-redirect?redirectUrl=/data_management/item_manage",
          "_blank",
        );
      } else {
        window.open(
          "http://yqbi-test.yucrm.cn/bi-web/yunzhou-common/system-redirect?redirectUrl=/data_management/item_manage",
          "_blank",
        );
      }
      return;
    },
    getList() {
      this.list = this.tagList.map((item) => ({
        ...item,
        expand: false,
        keyword: "",
        itemTagList: item.itemTagList.map((tag) => ({
          ...tag,
          checked: false,
        })),
      }));
      if (this.selectedTagIds.length > 0) {
        this.list.forEach((category) => {
          category.itemTagList.forEach((tag) => {
            if (this.selectedTagIds.includes(tag.id)) {
              tag.checked = true;
            }
          });
        });
      }
    },
    handleRefresh() {
      this.$emit("initExclude");
    },
    clearAll() {
      this.list.forEach((c) => {
        c.itemTagList.forEach((t) => {
          t.checked = false;
        });
      });
    },
    async handleSure() {
      this.$emit("update:showModal", false);
      const ids = [];
      this.list.forEach((category) => {
        category.itemTagList.forEach((tag) => {
          if (tag.checked) {
            ids.push(tag.id);
          }
        });
      });
      this.$emit("confirm", ids);
    },
    handleCancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped lang="scss">
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  .toolbar-right {
    display: flex;
    align-items: center;
    font-size: 14px;
    &-tips {
      color: #ff304f;
    }
    &-title {
      color: #333333;
    }
  }
}

.table {
  border: 1px solid #ebeef5;
  max-height: 500px;
  overflow: auto;
}
.footerBtnBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .checkText {
    color: #666666;
    font-weight: 400;
  }
}
.mb20 {
  margin-bottom: 20px;
}
.ml12 {
  margin-left: 12px !important;
}
</style>
